var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuDonate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(-52.189 -347.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(52.189 347.024)",
    fill: "#f4f3f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_heart_",
    "data-name": "FontAwsome (heart)",
    d: "M5.793,32.344a1.743,1.743,0,0,0-2.343.167l-.247.25-.247-.25a1.743,1.743,0,0,0-2.343-.167A1.742,1.742,0,0,0,.488,34.9l2.43,2.457a.4.4,0,0,0,.569,0L5.916,34.9a1.74,1.74,0,0,0-.123-2.557Z",
    transform: "translate(64.987 323.803)",
    fill: "none",
    stroke: "#816920",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_hand-holding-usd_",
    "data-name": "FontAwsome (hand-holding-usd)",
    d: "M18,44.111a1.2,1.2,0,0,0-1.357,0L13.7,46.1a2.269,2.269,0,0,1-1.274.377H8.663a.437.437,0,1,1,0-.862h2.493a1.033,1.033,0,0,0,1.059-.717.715.715,0,0,0,.015-.147.951.951,0,0,0-1.019-.861h-5.1a4.19,4.19,0,0,0-2.36.708L2.274,45.617H.51a.475.475,0,0,0-.51.431v2.587a.475.475,0,0,0,.51.431H11.872a2.282,2.282,0,0,0,1.274-.377l4.817-3.26a.824.824,0,0,0,.382-.651A.807.807,0,0,0,18,44.111Z",
    transform: "translate(60.099 320.132)",
    fill: "#816920",
    stroke: "#816920",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDonate);
export default __webpack_public_path__ + "static/media/icon-menu-donate.56d91c99.svg";
export { ForwardRef as ReactComponent };